













































































































































































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { StaffSurveyFormResponse, StaffSurveySubmissionWithCode } from "@/api";
import { VForm } from "@/common/vuetify_types";
import { StaffSurveyFormCollection } from "@/common/InspectionDataCollection";
import _ from "lodash";

@Component
class PublicStaffForm extends Vue {
  @Prop() readonly title!: string;
  @Ref("surveyForm") surveyForm!: VForm;

  step = 0; // Use 0-based index for array iteration
  submitting = false;
  loading = true;

  commentError = "";
  feedbackError = "";
  meetError = "";
  ratingError = "";

  surveyData: StaffSurveyFormCollection[] = [];
  payload: StaffSurveySubmissionWithCode = {
    id: 0,
    formId: 0,
    code: "",
    submittedDate: new Date().toISOString(),
    surveyData: [],
    createdAt: new Date().toISOString(),
  };

  async created() {
    this.loading = true;
    const code = this.$route.query.code as string;
    this.payload.code = code;
    this.loading = false;
  }

  get activeForm(): StaffSurveyFormResponse | null {
    return (
      (this.$store.getters[
        "staffSurvey/selectedForm"
      ] as StaffSurveyFormResponse) || null
    );
  }

  get questionLists(): StaffSurveyFormCollection[] {
    this.surveyData = [];

    if (this.activeForm && this.activeForm.questions) {
      this.payload.formId = this.activeForm.id || 0;

      const sortedQuestions = _.sortBy(
        this.activeForm.questions,
        ["order"],
        ["asc"],
      );

      let index = 0;
      _.forEach(sortedQuestions, question => {
        const data: StaffSurveyFormCollection = {
          index: index,
          question: question,
          data: {
            id: 0,
            submissionId: 0,
            questionId: question.id,
            answerText: undefined,
            answerBool: undefined,
            answerOptionId: undefined,
            answerOptionIds: [],
            answerRating: undefined,
            skipQuestion: false,
            createdAt: new Date().toISOString(),
          },
        };

        index++;
        this.surveyData.push(JSON.parse(JSON.stringify(data)));
      });

      return this.surveyData;
    }

    return [];
  }

  clearError(): void {
    this.commentError = "";
    this.feedbackError = "";
    this.meetError = "";
    this.ratingError = "";
  }

  validate(item: StaffSurveyFormCollection): boolean {
    this.clearError();
    let valid = true;

    const questionType = item.question.questionType;
    const isRequired = item.question.isRequired;
    const data = item.data;

    // Required field validation
    if (isRequired) {
      if (questionType === "rating" && data.answerRating === undefined) {
        this.feedbackError = "Please provide a rating (1-5).";
        valid = false;
      } else if (
        (questionType === "single_choice" || questionType === "yes_no") &&
        data.answerOptionId === undefined
      ) {
        this.feedbackError = "Please select an option.";
        valid = false;
      } else if (
        questionType === "multiple_choice" &&
        (data.answerOptionIds === undefined ||
          data.answerOptionIds?.length === 0)
      ) {
        this.feedbackError = "Please select at least one option.";
        valid = false;
      } else if (
        questionType === "text" &&
        (data.answerText === undefined || data.answerText?.trim() === "")
      ) {
        this.commentError = "Please provide an answer.";
        valid = false;
      }
    } else {
      // Optional field validation - must answer OR skip
      if (questionType === "rating") {
        if (data.answerRating === undefined && !data.skipQuestion) {
          this.meetError = "Please provide a rating or skip this question.";
          valid = false;
        }
      } else if (questionType === "single_choice") {
        if (data.answerOptionId === undefined && !data.skipQuestion) {
          this.meetError = "Please select an option or skip this question.";
          valid = false;
        }
      } else if (questionType === "text") {
        if (
          (data.answerText === undefined || data.answerText?.trim() === "") &&
          !data.skipQuestion
        ) {
          this.meetError = "Please provide an answer or skip this question.";
          valid = false;
        }
      }
    }

    return valid;
  }

  nextQuestion(item: StaffSurveyFormCollection): void {
    if (this.validate(item)) {
      if (this.step < this.questionLists.length - 1) {
        this.step++;
      }
    }
  }

  previousQuestion(): void {
    this.clearError();
    if (this.step > 0) {
      this.step--;
    }
  }

  async submitForm(item: StaffSurveyFormCollection): Promise<void> {
    if (!this.validate(item)) {
      return;
    }

    this.submitting = true;

    try {
      this.payload.surveyData = this.surveyData.map(q => ({
        ...q.data,
        answerRating: q.data.skipQuestion ? 0 : q.data.answerRating,
      }));

      await this.$store.dispatch(
        "staffSurvey/createStaffSurveySubmissionByCode",
        {
          requestBody: this.payload,
        },
      );

      this.complete();
    } catch (error) {
      console.error("Error submitting survey:", error);
      alert("Error submitting survey. Please try again.");
    } finally {
      this.submitting = false;
    }
  }

  complete(): void {
    alert("🎉 Survey submitted successfully! Thank you for your feedback.");
    this.$router.push("/");
  }
}

export default PublicStaffForm;
